// extracted by mini-css-extract-plugin
export default {"container":"egMlWC","updatedCheckoutSummary":"fylKe4","srOnly":"k3W6L0","timer":"qA3gkp"};